import { Provider } from '@angular/core';

import { DefaultRedirectStrategy, REDIRECT_STRATEGIES, RedirectCommandProvider } from '@guardfinder/shared';

import { AppInitRedirectStrategy } from '../infrastructure/app-init-redirect-strategy';
import { UserLogoutRedirectStrategy } from '../infrastructure/user-logout-redirect-strategy';

export function provideRedirectStrategies(): Provider[] {
    return [
        RedirectCommandProvider,
        DefaultRedirectStrategy,
        {
            provide: REDIRECT_STRATEGIES,
            useClass: AppInitRedirectStrategy,
            multi: true
        },
        {
            provide: REDIRECT_STRATEGIES,
            useClass: UserLogoutRedirectStrategy,
            multi: true
        }
    ];
}
